import axios from 'axios';
import { CreateShippingRateRequest } from '../../common/model/dto/shipping-rate/create-shipping-rate-request';
import { ADMIN_SHIPPING_RATE_ROUTE } from '../../api/backend';
import { UpdateShippingRateRequest } from '../../common/model/dto/shipping-rate/update-shipping-rate-request';
import { Paginated } from '../../common/types';
import { ShippingRate } from '../../common/model/dto/shipping-rate/shipping-rate';

export const getAdminShippingRates = async (
  query: string
): Promise<Paginated<ShippingRate>> => {
  const { data } = await axios.get(`/${ADMIN_SHIPPING_RATE_ROUTE}?${query}`);

  return data;
};

export const getShippingRateById = async (
  id: string
): Promise<ShippingRate> => {
  const { data } = await axios.get(`/${ADMIN_SHIPPING_RATE_ROUTE}/${id}`);

  return data;
};

export const createShippingRate = async (
  createShippingRateRequest: CreateShippingRateRequest
): Promise<ShippingRate> => {
  return await axios.post(
    `${ADMIN_SHIPPING_RATE_ROUTE}`,
    createShippingRateRequest
  );
};

export const updateShippingRate = async (
  id: string,
  updateShippingRateRequest: UpdateShippingRateRequest
) => {
  return await axios.patch(
    `${ADMIN_SHIPPING_RATE_ROUTE}/${id}`,
    updateShippingRateRequest
  );
};

export const deleteShippingRate = async (id: string) => {
  return await axios.delete(`${ADMIN_SHIPPING_RATE_ROUTE}/${id}`);
};
